import React from 'react'

const SettingsNotification = () => {
    return (
        <div className="_nft_settings_profile_notification_wrap">
            <h3 className="_nft_settings_profile_form01_txt">Notifications</h3>
            <div className="_nft_settings_profile_notification">
                <div className="_nft_settings_profile_notification_list">
                    <div className="_nft_settings_profile_notification_list_cont mb-5">
                        <p className="_nft_settings_profile_notification_list_cont01">NFTs
                            updates and community announcements
                        </p>
                        <input type="checkbox" id="toggler1" />
                        <label htmlFor="toggler1" className="_nft_settings_profile_notification_list_cont_inactiv_ic">
                            <span className="_nft_settings_profile_notification_list_cont_inactiv_ic_sp" />
                        </label>
                    </div>
                    <div className="_nft_settings_profile_notification_list_cont mb-5">
                        <p className="_nft_settings_profile_notification_list_cont01">NFTs
                            Item Sold
                        </p>
                        <input type="checkbox" id="toggler2" />
                        <label htmlFor="toggler2" className="_nft_settings_profile_notification_list_cont_inactiv_ic">
                            <span className="_nft_settings_profile_notification_list_cont_inactiv_ic_sp" />
                        </label>
                    </div>
                    <div className="_nft_settings_profile_notification_list_cont mb-5">
                        <p className="_nft_settings_profile_notification_list_cont01">NFTs
                            Bid Activity
                        </p>
                        <input type="checkbox" id="toggler3" />
                        <label htmlFor="toggler3" className="_nft_settings_profile_notification_list_cont_inactiv_ic">
                            <span className="_nft_settings_profile_notification_list_cont_inactiv_ic_sp" />
                        </label>
                    </div>
                    <div className="_nft_settings_profile_notification_list_cont mb-5">
                        <p className="_nft_settings_profile_notification_list_cont01">NFTs
                            Auction Expiration
                        </p>
                        <input type="checkbox" id="toggler4" />
                        <label htmlFor="toggler4" className="_nft_settings_profile_notification_list_cont_inactiv_ic">
                            <span className="_nft_settings_profile_notification_list_cont_inactiv_ic_sp" />
                        </label>
                    </div>
                    <div className="_nft_settings_profile_notification_list_cont mb-5">
                        <p className="_nft_settings_profile_notification_list_cont01">NFTs
                            Owned Item Updates
                        </p>
                        <input type="checkbox" id="toggler5" />
                        <label htmlFor="toggler5" className="_nft_settings_profile_notification_list_cont_inactiv_ic">
                            <span className="_nft_settings_profile_notification_list_cont_inactiv_ic_sp" />
                        </label>
                    </div>
                    <div className="_nft_settings_profile_notification_list_cont mb-5">
                        <p className="_nft_settings_profile_notification_list_cont01">NFTs
                            Successful Purchase
                        </p>
                        <input type="checkbox" id="toggler6" />
                        <label htmlFor="toggler6" className="_nft_settings_profile_notification_list_cont_inactiv_ic">
                            <span className="_nft_settings_profile_notification_list_cont_inactiv_ic_sp" />
                        </label>
                    </div>
                    <div className="_nft_settings_profile_notification_list_cont mb-5">
                        <p className="_nft_settings_profile_notification_list_cont01">NFTs
                            Allblock Newsletter
                        </p>
                        <input type="checkbox" id="toggler7" />
                        <label htmlFor="toggler7" className="_nft_settings_profile_notification_list_cont_inactiv_ic">
                            <span className="_nft_settings_profile_notification_list_cont_inactiv_ic_sp" />
                        </label>
                    </div>
                </div>
            </div>
            <button type="submit" className="btn btn-primary _nft_settings_profile_notification_btn">Save</button>
        </div>
    )
}

export default SettingsNotification;